import React from 'react'
import { Controller } from 'react-hook-form'
import IconDropdown from 'components/styledFormElements/IconDropdown'
import ColorPickerField from 'components/styledFormElements/ColorPickerField'
import { getImageSrc } from 'services/util'
import { X } from 'lucide-react'

type MediaAssetsPanelProps = {
    control: any
    errors: any
    icons: any[]
}

const MediaAssetsPanel: React.FC<MediaAssetsPanelProps> = ({
    control,
    errors,
    icons,
}) => {
    return (
        <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg p-6 shadow-sm h-[45vh] flex flex-col">
            <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">
                Media Assets
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Icon <span className="text-red-700">*</span>
                    </label>

                    <Controller
                        name="icon"
                        control={control}
                        render={({ field }) => {
                            const iconValue = field.value;
                            return (
                                <div className="space-y-2">
                                    {/* {(() => {
                                    const selectedIcon = icons.find(
                                        (icon: any) =>
                                            icon.icon === field.value
                                    )
                                    return (
                                        <IconDropdown
                                            value={selectedIcon?.id || null}
                                            onChange={(selectedIcon: any) => {
                                                const iconKey =
                                                    selectedIcon?.path ||
                                                    selectedIcon?.image ||
                                                    selectedIcon?.icon ||
                                                    ''
                                                field.onChange(iconKey)
                                            }}
                                        />
                                    )
                                 })()} */}
                                    {iconValue ? (
                                        <div className="flex items-center justify-between border border-gray-300 dark:border-slate-600 rounded-md px-3 py-2 bg-white dark:bg-slate-800">
                                            <div className="flex items-center gap-2">
                                                <img
                                                    src={
                                                        iconValue.startsWith('http')
                                                            ? iconValue
                                                            : getImageSrc(iconValue)
                                                    }
                                                    alt="Selected icon"
                                                    className="w-6 h-6 object-contain"
                                                />
                                                <span className="text-sm text-gray-700 dark:text-gray-200">
                                                    Icon selected
                                                </span>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    field.onChange('');
                                                }}
                                                className="ml-2 p-1 bg-black/70 hover:bg-black text-white rounded-full"
                                            >
                                                <X size={14} />
                                            </button>
                                        </div>
                                    )
                                        : (
                                            <IconDropdown
                                                value={iconValue}
                                                onChange={(selectedIcon: any) => {
                                                    const iconKey =
                                                        selectedIcon?.path ||
                                                        selectedIcon?.image ||
                                                        selectedIcon?.icon ||
                                                        '';

                                                    field.onChange(iconKey);
                                                }}
                                            />
                                        )}

                                    {field.value ? (
                                        <div className="flex items-center gap-2 text-xs text-gray-600 dark:text-gray-300">
                                            <span>Preview:</span>
                                            <img
                                                src={getImageSrc(field.value)}
                                                alt="Tool icon preview"
                                                className="w-5 h-5 object-contain"
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            )
                        }}
                    />
                    {errors.icon ? (
                        <p className="text-red-500 text-xs mt-1">
                            {errors.icon.message}
                        </p>
                    ) : null}
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <Controller
                        name="primaryColor"
                        control={control}
                        render={({ field }) => (
                            <ColorPickerField
                                label="Primary Color"
                                required
                                value={field.value}
                                onChange={field.onChange}
                                error={errors.primaryColor?.message}
                            />
                        )}
                    />
                    <Controller
                        name="secondaryColor"
                        control={control}
                        render={({ field }) => (
                            <ColorPickerField
                                label="Secondary Color"
                                required
                                value={field.value}
                                onChange={field.onChange}
                                error={errors.secondaryColor?.message}
                            />
                        )}
                    />
                </div>
            </div>
        </div>
    )
}

export default MediaAssetsPanel

